module.exports = __webpack_public_path__ + "img/logo.95e4c159.png";